import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Gallery",
  "use": "Gallery-usage",
  "viewBox": "0 0 36 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 28\" id=\"Gallery\"><g fill-rule=\"evenodd\" transform=\"translate(0 -5)\"><path d=\"M.563 5.063h34.874v27H.563v-27zM4.5 9v19.125h27V9h-27z\" /><path d=\"M18 27a8.437 8.437 0 1 1 0-16.875A8.437 8.437 0 0 1 18 27zm.003-1.995a6.44 6.44 0 1 0 0-12.88 6.44 6.44 0 0 0 0 12.88zM18 23.063a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z\" /><circle cx=\"28.406\" cy=\"12.094\" r=\"1.969\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol